import { IIconProps } from '../../types/IconProps.interface'

export const IconWarning = ({ color = 'white' }: IIconProps) => {
  return (
    <svg fill='none' height='13' viewBox='0 0 15 13' width='15' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.50341 9.50575L7.51117 9.50575M7.50342 7.5L7.50342 4.5M2.05769 12.5L12.9491 12.5C14.1469 12.5 14.8932 11.2466 14.2897 10.2486L8.84398 1.24277C8.24508 0.252412 6.76173 0.252412 6.16284 1.24277L0.717163 10.2485C0.113635 11.2466 0.859918 12.5 2.05769 12.5Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
